export default "__VITE_ASSET__KtlV3S____"